import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageSerch from "../SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import { encryptId, loginapi } from "../../../services/apiService"; // Adjust the import path as needed
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Add this import for eye icons
import { oneKlicks, sendSMS } from "../../../SDK/oneclick";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Link } from "react-router-dom";
import { useAuth } from '../../../context/AuthContext';
import './MobileLoginScreen.css'; // Import Android-style CSS
import ImageShow from "../../../Uitiles/ImageShow";
import { getSettings } from "../../../services/settingsService";
import { FaArrowLeft } from 'react-icons/fa';

const LoginScreen = () => {
    const navigate = useNavigate();
    const { login, isLoggedIn, userData } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loginbutton, setLoginbutton] = useState(false);
    const [settings, setSettings] = useState({});
    const [errors, setErrors] = useState({
        email: "",
        password: "",
        phone: ""
    });
    const [phoneNumber, setPhoneNumber] = useState("");
    const [user, setUser] = useState(null);
    const [showOtpForm, setShowOtpForm] = useState(false);
    const [otp, setOtp] = useState("");
    const [tempUserData, setTempUserData] = useState(null);
    const [loginMethod, setLoginMethod] = useState('email');
    const [resendTimer, setResendTimer] = useState(0);
    const [canResendOtp, setCanResendOtp] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        getSettings().then(settings => {
            setSettings(settings);
        });
    }, []);

    useEffect(() => {
        checklogin();
        let timer;
        if (resendTimer > 0) {
            timer = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev <= 1) {
                        setCanResendOtp(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [resendTimer]);


    const checklogin = async () => {
        if (isLoggedIn) {
            handleNavigation(userData);
        } else {
            navigate("/mobile/login");
        }
    }

    const startResendTimer = () => {
        setResendTimer(60);
        setCanResendOtp(false);
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            email: "",
            password: "",
            phone: ""
        };

        if (loginMethod === 'email') {
            if (!email.trim()) {
                newErrors.email = "Email is required";
                isValid = false;
            } else if (!/\S+@\S+\.\S+/.test(email)) {
                newErrors.email = "Please enter a valid email address";
                isValid = false;
            }

            if (!password) {
                newErrors.password = "Password is required";
                isValid = false;
            } else if (password.length < 6) {
                newErrors.password = "Password must be at least 6 characters";
                isValid = false;
            }
        } else {
            if (!phoneNumber) {
                newErrors.phone = "Phone number is required";
                isValid = false;
            }
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        try {
            if (loginMethod === 'email') {
                console.log('Attempting email login...');
                const loginResponse = await loginapi(email, password);
                console.log('Login response:', loginResponse);

                const user = loginResponse.data[0];

                if (user) {
                    if (user.status === "2") {
                        toast.error("Your account has been deleted. Please contact support.");
                        return;
                    }

                    const userData = {
                        id: user.id,
                        email: user.email,
                        user_type: user.user_type,
                        display_name: user.display_name || user.name || user.email
                    };

                    console.log('User data prepared for login:', userData);
                    // Use the login function from AuthContext
                    const loginSuccess = await login(userData);
                    console.log('Login success status:', loginSuccess);

                    if (loginSuccess) {
                        localStorage.setItem('presentuser', JSON.stringify(userData));
                        toast.success("Login successful!", { autoClose: 2000 });
                        handleNavigation(userData);
                    } else {
                        console.error('Login failed - login function returned false');
                        toast.error("Login failed. Please try again.");
                    }
                } else {
                    console.error('check login data parmaa');
                    toast.error("Invalid credentials. Please try again.");
                }
            } else {
                // Phone login logic
                const tableSchema = "";
                const tableName = "users";
                const conditions = {
                    phone: phoneNumber
                };
                const orderBy = "id DESC";
                const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");

                if (phoneLoginResponse.data.length > 0) {
                    const user = phoneLoginResponse.data[0];
                    const generatedOtp = Math.floor(100000 + Math.random() * 900000);

                    try {
                        const body = `Hey! Here's your MeddyList verification code: ${generatedOtp}. Use it to continue. Keep it secure!`;
                        const message = await sendSMS(phoneNumber, body);

                        if (message.sid) {
                            const data = {
                                otp: generatedOtp,
                                otp_expiry: new Date(Date.now() + 10 * 60000)
                            };
                            const condition = {
                                phone: phoneNumber
                            };

                            const storeOtpResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                            if (storeOtpResponse.success) {
                                setTempUserData({ phone: phoneNumber, id: user.id });
                                setShowOtpForm(true);
                                startResendTimer();
                                localStorage.setItem('presentuser', JSON.stringify({ phone: phoneNumber, id: user.id }));
                                toast.success("OTP sent to your phone number", { autoClose: 3000 });
                            } else {
                                toast.error("Failed to store OTP. Please try again.");
                            }
                        }
                    } catch (twilioError) {
                        console.error("Twilio error:", twilioError);
                        toast.error("Failed to send OTP. Please try again.");
                    }
                } else {
                    try {
                        const tableSchema = "";
                        const tableName = "pharmacies";
                        const conditions = {
                            phone: phoneNumber
                        };
                        const orderBy = "id DESC";
                        const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                        if (phoneLoginResponse.data.length > 0) {
                            const user = phoneLoginResponse.data[0];
                            const generatedOtp = Math.floor(100000 + Math.random() * 900000);

                            try {
                                const body = `Hey! Here's your MeddyList verification code: ${generatedOtp}. Use it to continue. Keep it secure!`;
                                const message = await sendSMS(phoneNumber, body);

                                console.log("message send otp", message);

                                if (message.sid) {
                                    const data = {
                                        otp: generatedOtp,
                                        otp_expiry: new Date(Date.now() + 10 * 60000)
                                    };
                                    const condition = {
                                        phone: phoneNumber
                                    };

                                    const storeOtpResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                                    if (storeOtpResponse.success) {
                                        setTempUserData({ phone: phoneNumber, id: user.id });
                                        setShowOtpForm(true);
                                        startResendTimer();
                                        localStorage.setItem('presentuser', JSON.stringify({ phone: phoneNumber, id: user.id }));
                                        toast.success("OTP sent to your phone number", { autoClose: 3000 });
                                    } else {
                                        toast.error("Failed to store OTP. Please try again.");
                                    }
                                }
                            } catch (twilioError) {
                                console.error("Twilio error:", twilioError);
                                toast.error("Failed to send OTP. Please try again.");
                            }
                        } else {
                            toast.error("Phone number not found. Please check and try again.");
                        }
                    } catch (error) {
                        console.error("Phone number not found. Please check and try again.");
                        toast.error("Something went wrong. Please try again.");
                    }
                }
            }
        } catch (error) {
            console.error("Login error:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const verifyOtp = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                phone: tempUserData.phone,
                otp: otp
            };

            const verifyResponse = await oneKlicks.read(tableSchema, tableName, conditions, "", "", "", "");

            if (verifyResponse.success && verifyResponse.data.length > 0) {
                const userData = verifyResponse.data[0];

                const otpExpiry = new Date(userData.otp_expiry);
                if (otpExpiry < new Date()) {
                    toast.error("OTP has expired. Please request a new one.");
                    return;
                }

                // Use the login function from AuthContext
                const loginSuccess = await login({
                    id: userData.id,
                    email: userData.email,
                    user_type: userData.user_type,
                    display_name: userData.display_name || userData.email
                });

                if (loginSuccess) {
                    setShowOtpForm(false);
                    localStorage.setItem('presentuser', JSON.stringify({ id: userData.id, phone: userData.phone }));
                    toast.success("Login successful!", { autoClose: 2000 });
                    handleNavigation(userData);
                } else {
                    toast.error("Login failed. Please try again.");
                }
            } else {
                const tableSchema = "";
                const tableName = "pharmacies";
                const conditions = {
                    phone: tempUserData.phone
                };
                const orderBy = "id DESC";
                const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                if (phoneLoginResponse.data.length > 0) {
                    const user = phoneLoginResponse.data[0];
                    const generatedOtp = Math.floor(100000 + Math.random() * 900000);
                } else {
                    toast.error("Invalid OTP. Please try again.");
                }
            }
        } catch (error) {
            console.error("OTP verification error:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const resendOtp = async () => {
        if (!canResendOtp) return;

        try {
            const generatedOtp = Math.floor(100000 + Math.random() * 900000);
            const tableSchema = "";
            const tableName = "users";

            const body = `Here's your MeddyList code again: ${generatedOtp}. Use it within 10 minutes. Need help? Reply to this message.`;

            const message = await sendSMS(phoneNumber, body);

            if (message.sid) {
                const data = {
                    otp: generatedOtp,
                    otp_expiry: new Date(Date.now() + 10 * 60000)
                };
                const condition = {
                    phone: tempUserData.phone
                };

                const updateResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                if (updateResponse.success) {
                    startResendTimer();
                    toast.success("New OTP sent to your phone number", { autoClose: 3000 });
                } else {
                    const tableSchema = "";
                    const tableName = "pharmacies";
                    const conditions = {
                        phone: tempUserData.phone
                    };
                    const orderBy = "id DESC";
                    const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                    if (phoneLoginResponse.data.length > 0) {
                        const user = phoneLoginResponse.data[0];
                        const generatedOtp = Math.floor(100000 + Math.random() * 900000);
                        const data = {
                            otp: generatedOtp,
                            otp_expiry: new Date(Date.now() + 10 * 60000)
                        };
                        const condition = {
                            phone: tempUserData.phone
                        };
                        const updateResponse = await oneKlicks.update(tableSchema, tableName, data, condition);
                        if (updateResponse.success) {
                            toast.success("New OTP sent to your phone number", { autoClose: 3000 });
                        }
                    } else {
                        toast.error("Failed to update OTP. Please try again.");
                    }

                }
            }
        } catch (error) {
            console.error("Resend OTP error:", error);
            toast.error("Failed to resend OTP. Please try again.");
        }
    };

    const handleNavigation = (userData) => {
        setTimeout(() => {
            switch (userData.user_type?.toLowerCase()) {
                case "admin":
                    navigate("/admin-dashboard");
                    break;
                case "doctor":
                    navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    break;
                case "hospitals":
                    navigate("/hospital/dashboard");
                    break;
                case "regular_users":
                    navigate("/patient/dashboard");
                    break;
                case "patient":
                    navigate("/user-dashboard");
                    break;
                case "pharmacy":
                    navigate("/pharmacy/dashboard");
                    break;
                case "blood_bank":
                    navigate("/blood-bank/dashboard");
                    break;
                case "diagnostic":
                    navigate("/diagnostic/dashboard");
                    break;
                case "insurance":
                case "insurance_company":
                    navigate("/insurance-dashboard");
                    break;
                case "user":
                    // Stay on home page - user can access dashboard from header dropdown
                    navigate("/");
                    break;
                case "administrator":
                    navigate("/superadmin/dashboard");
                    break;
                case "staff":
                    navigate("/superadmin/dashboard");
                    break;
                case "editor":
                    navigate("/editor/dashboard");
                    break;
                default:
                    // For unknown roles, stay on home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    return (
        <>
            <main id="dc-main" className="mobile-login dc-main dc-haslayout">
                <div className="mobile-login container">
                    <div className="mobile-login dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
                        <div className="mobile-login main-page-wrapper">
                            <div className="mobile-login row">
                                <div className="mobile-login col-lg-12 col-md-12">
                                    <div className="mobile-login dc-modalcontent modal-content login_bodey">
                                        <div className="mobile-login dc-loginformholds">
                                            {/* Back Button */}
                                            <button
                                                className="forgot-password back-button"
                                                onClick={() => navigate("/mobile/home")}
                                                aria-label="Go back"
                                                style={{ left: '10px' }}
                                            >
                                                <FaArrowLeft />
                                            </button>
                                            <div className="mobile-login dc-loginheader">
                                                <div className="login-logo">
                                                    <ImageShow url={settings.favicon_url} height={0} width={0} />
                                                </div>
                                                <span>Sign In</span>
                                                <p className="welcome-message">Hi! Welcome back, you've been missed</p>
                                            </div>
                                            {!showOtpForm ? (
                                                <form className="mobile-login dc-formtheme dc-loginform">
                                                    <fieldset>
                                                        {loginMethod === 'email' ? (
                                                            <>
                                                                <div className="mobile-login form-group">
                                                                    <label htmlFor="email">Email</label>
                                                                    <input
                                                                        id="email"
                                                                        type="email"
                                                                        name="email"
                                                                        className={`mobile-login form-control ${errors.email ? 'is-invalid' : ''}`}
                                                                        placeholder="example@gmail.com"
                                                                        value={email}
                                                                        onChange={(e) => {
                                                                            setEmail(e.target.value);
                                                                            setErrors(prev => ({ ...prev, email: "" }));
                                                                        }}
                                                                    />
                                                                    {errors.email && (
                                                                        <div className="mobile-login invalid-feedback" style={{ display: 'block' }}>
                                                                            {errors.email}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="mobile-login form-group position-relative">
                                                                    <label htmlFor="password">Password</label>
                                                                    <input
                                                                        id="password"
                                                                        type={showPassword ? "text" : "password"}
                                                                        name="password"
                                                                        className={`mobile-login form-control ${errors.password ? 'is-invalid' : ''}`}
                                                                        placeholder="••••••••••"
                                                                        value={password}
                                                                        onChange={(e) => {
                                                                            setPassword(e.target.value);
                                                                            setErrors(prev => ({ ...prev, password: "" }));
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="mobile-login btn btn-link"
                                                                        onClick={togglePasswordVisibility}
                                                                    >
                                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                    </button>
                                                                    {errors.password && (
                                                                        <div className="mobile-login invalid-feedback" style={{ display: 'block' }}>
                                                                            {errors.password}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <Link to="/mobile/forgot-password" className="mobile-login dc-forgot-password">
                                                                    Forgot Password?
                                                                </Link>
                                                            </>
                                                        ) : (
                                                            <div className="mobile-login form-group">
                                                                <label htmlFor="phone">Phone Number</label>
                                                                <PhoneInput
                                                                    id="phone"
                                                                    international
                                                                    defaultCountry="IN"
                                                                    value={phoneNumber}
                                                                    onChange={setPhoneNumber}
                                                                    placeholder="Enter phone number"
                                                                    className="mobile-login form-control frontend-phone-input"
                                                                />
                                                            </div>
                                                        )}


                                                        <button
                                                            type="submit"
                                                            className="mobile-login dc-btn do-login-button"
                                                            onClick={handleLogin}
                                                            disabled={isLoading}
                                                        >
                                                            {isLoading ? (
                                                                <>
                                                                    <span className="mobile-login spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                    Loading...
                                                                </>
                                                            ) : (
                                                                loginMethod === 'email' ? 'Sign In' : 'Send OTP'
                                                            )}
                                                        </button>
                                                    </fieldset>

                                                    {/* Social Login Divider */}
                                                    <div className="mobile-login social-divider">
                                                        <span>Or sign in with</span>
                                                    </div>

                                                    {/* Social Login Buttons */}
                                                    <div className="mobile-login social-login-buttons">
                                                        <button type="button" className="mobile-login social-btn" title="Sign in with Apple">
                                                            <svg viewBox="0 0 24 24" fill="#000000">
                                                                <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                                                            </svg>
                                                        </button>
                                                        <button type="button" className="mobile-login social-btn" title="Sign in with Google">
                                                            <svg viewBox="0 0 24 24">
                                                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                                                            </svg>
                                                        </button>
                                                        <button type="button" className="mobile-login social-btn" title="Sign in with Facebook">
                                                            <svg viewBox="0 0 24 24" fill="#1877F2">
                                                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                                            </svg>
                                                        </button>
                                                    </div>

                                                    {/* Footer Info */}
                                                    <div className="">
                                                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Don't have an account? <Link to="/mobile/authentication"> <span style={{ marginLeft: '5px' }}>  </span>Sign Up</Link></span>
                                                    </div>
                                                </form>
                                            ) : (
                                                <form className="mobile-login dc-formtheme dc-loginform do-login-form">
                                                    <fieldset>
                                                        <div className="mobile-login form-group">
                                                            <input
                                                                type="text"
                                                                name="otp"
                                                                value={otp}
                                                                onChange={(e) => setOtp(e.target.value)}
                                                                className="mobile-login form-control"
                                                                placeholder="Enter 6-digit OTP"
                                                                maxLength="6"
                                                            />
                                                        </div>
                                                        <div className="mobile-login dc-logininfo">
                                                            <button
                                                                type="submit"
                                                                className="mobile-login dc-btn do-login-button"
                                                                onClick={verifyOtp}
                                                                disabled={isLoading}
                                                                style={{ position: 'relative', minWidth: '120px' }}
                                                            >
                                                                {isLoading ? (
                                                                    <>
                                                                        <span className="mobile-login spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        Verifying...
                                                                    </>
                                                                ) : (
                                                                    'Verify OTP'
                                                                )}
                                                            </button>
                                                        </div>
                                                    </fieldset>
                                                    <div className="mobile-login dc-loginfooterinfo">
                                                        <Link to="/mobile/login" onClick={() => setShowOtpForm(false)}>Back to Login</Link>
                                                        <Link
                                                            href="#"
                                                            onClick={resendOtp}
                                                            className={`dc-forgot-password ${!canResendOtp ? 'disabled' : ''}`}
                                                            style={{
                                                                opacity: canResendOtp ? 1 : 0.5,
                                                                cursor: canResendOtp ? 'pointer' : 'not-allowed',
                                                                textDecoration: 'none'
                                                            }}
                                                        >
                                                            {resendTimer > 0
                                                                ? `Resend OTP in ${formatTime(resendTimer)}`
                                                                : 'Resend OTP'}
                                                        </Link>
                                                    </div>
                                                </form>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};


export default LoginScreen;
